import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import TextInput from 'components/Inputs/TextInput/TextInput';
import Select from 'components/Inputs/Select/Select';
import FormValidator from 'utils/FormValidator';
import ErrorConstants from 'utils/ErrorConstants';
import ErrorsUtils from 'utils/Errors';
import localeUtils from 'utils/LanguageLocale';

const { COUNTRIES, isCountryInternational } = localeUtils;

function StateProvinceField({
    state = '',
    country = '',
    stateList = [],
    isInternational = false,
    displayCityStateInputs = false,
    cityStateZipInvalid = false,
    isFCFinalReleaseEnabled = false,
    isSubscription = false,
    modalTitle = '',
    localization = {},
    onChange,
    stateSelectRef,
    regionInputRef,
    fireFormErrorAnalytics
}) {
    const { region, province, stateRegion } = localization;
    const isCanada = country === COUNTRIES.CA;
    const isUS = localeUtils.isUS();

    const stateOrProvinceError = () => {
        return !isCountryInternational(country) && !state;
    };

    const validateState = () => {
        if (stateOrProvinceError()) {
            if (isSubscription && fireFormErrorAnalytics) {
                fireFormErrorAnalytics(modalTitle, ErrorsUtils.getMessage(ErrorConstants.ERROR_CODES.STATE));
            }

            return ErrorConstants.ERROR_CODES.STATE;
        }

        return null;
    };

    if (isInternational) {
        return (
            <TextInput
                name='state'
                label={region}
                autoComplete='address-level1'
                autoCorrect='off'
                maxLength={FormValidator.FIELD_LENGTHS.stateRegion}
                value={state}
                onChange={onChange}
                ref={regionInputRef}
            />
        );
    }

    if (displayCityStateInputs) {
        return (
            <Select
                label={isCanada ? province : stateRegion}
                autoComplete='address-level1'
                name='state'
                value={state}
                required={true}
                hideAsterisk={isUS || isFCFinalReleaseEnabled}
                invalid={cityStateZipInvalid || stateOrProvinceError()}
                onChange={onChange}
                ref={stateSelectRef}
                isCanada={isCanada}
                validateError={validateState}
                data-at={Sephora.debug.dataAt('state_region_select')}
            >
                {stateList &&
                    stateList.length > 0 &&
                    stateList.map((stateItem, index) =>
                        // remove `select a state/region`
                        // `hidden` prop not respected by iOS safari
                        index > 0 ? (
                            <option
                                key={stateItem.name}
                                value={stateItem.name}
                                children={stateItem.description}
                            />
                        ) : null
                    )}
            </Select>
        );
    }

    return (
        <TextInput
            name='state'
            maxLength={FormValidator.FIELD_LENGTHS.stateRegion}
            customStyle={{
                root: { display: 'none' }
            }}
        />
    );
}

export default wrapFunctionalComponent(StateProvinceField, 'StateProvinceField');
